var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/circleci/project/@static/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["@modules/modals/templates/events-view.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"modal-inner-container padding--bottom-zero ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSize"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsPadding"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsBackgroundColor"), env.opts.autoescape);
output += "\">\n    <button class=\"modal__close-btn btn\" data-js-ui=\"close-modal\">\n        <span class=\"modal__close-btn-label\" data-auto-translate=\"true\">Close</span>\n        <span class=\"modal__close-btn-icon icon-close\"></span>\n    </button>\n    <button class=\"modal__print-btn btn\" data-js-ui=\"print-modal\">\n        <span class=\"modal__print-btn-label\" data-auto-translate=\"true\">Print</span>\n        <span class=\"modal__print-btn-icon icon-print\"></span>\n    </button>\n    <div class=\"modal__text-container\">\n        <div class=\"container-fluid padding--kill\">\n            <h1 class=\"modal__title style--underlined\" data-auto-translate=\"true\">\n                ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsTitle"))), env.opts.autoescape);
output += "\n            </h1>\n            <div class=\"row no-gutters\">\n                <div class=\"col-sm-10\">\n                    <p class=\"modal__text\" data-auto-translate=\"true\">\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsText"), env.opts.autoescape);
output += "\n                    </p>\n\n\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "jsCost") || runtime.contextOrFrameLookup(context, frame, "jsWhen") || runtime.contextOrFrameLookup(context, frame, "jsWhere")) {
output += "\n                        <ul class=\"modal__list style--bolded-spacing--small\">\n\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "jsCost")) {
output += "\n                                <li class=\"modal__list-item\">\n                                    <span class=\"modal__list-item-title\" data-auto-translate=\"true\">Cost:</span>\n                                    <span class=\"modal__list-item-text\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsCost"), env.opts.autoescape);
output += "</span>\n                                </li>\n                            ";
;
}
output += "\n\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "jsWhen")) {
output += "\n                                <li class=\"modal__list-item\">\n                                    <span class=\"modal__list-item-title\" data-auto-translate=\"true\">When:\n                                    </span>\n                                    <span class=\"modal__list-item-text\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsWhen"), env.opts.autoescape);
output += "</span>\n                                </li>\n                            ";
;
}
output += "\n\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "jsWhere")) {
output += "\n                                <li class=\"modal__list-item\">\n                                    <span class=\"modal__list-item-title\" data-auto-translate=\"true\">Where:</span>\n                                    <span class=\"modal__list-item-text\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsWhere"), env.opts.autoescape);
output += "</span>\n                                </li>\n                            ";
;
}
output += "\n\n                        </ul>\n                    ";
;
}
output += "\n\n                    <p class=\"modal__text modal__text--disclaimer\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsDisclaimerText"), env.opts.autoescape);
output += "</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal__gallery-container\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "jsGalleryTitle")) {
output += "\n        <h4 class=\"modal__gallery-title\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsGalleryTitle"), env.opts.autoescape);
output += "</h4>\n        ";
;
}
output += "\n        <div class=\"modal__gallery-wrapper\">\n            <div class=\"modal__gallery\" data-js-view=\"eventModalGallery\">\n                ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "jsGalleryItems");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                    <div class=\"modal__gallery-item\">\n                        <img class=\"modal__gallery-item__image img-fluid\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"image"), env.opts.autoescape);
output += "\" />\n                        <span class=\"modal__gallery-item__title0\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "</span>\n                        <span class=\"modal__gallery-item__subtitle\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"caption"), env.opts.autoescape);
output += "</span>\n                    </div>\n                ";
;
}
}
frame = frame.pop();
output += "\n            </div>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["@modules/modals/templates/events-view.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./@modules/modals/templates/events-view.njk
// module id = 478
// module chunks = 0